const companyListGridConfig = {
    columns: [
        {
            id: 1,
            width: 250,
            selector: 'name',
            name: 'Име',
            sequenceNumber: 1,
            type: 'string'
        },
        {
            id: 2,
            width: 250,
            selector: 'address',
            name: 'Адрес',
            sequenceNumber: 2,
            type: 'string'
        },
        {
            id: 3,
            width: 250,
            selector: 'countryName',
            name: 'Държава',
            sequenceNumber: 3,
            type: 'string',
            filterComponent: 'CountryDropdown'
        }
    ],
    props: {
        headerRowHeight: 50,
        rowHeight: 52,
        tableHeight: 600,
        filterable: true,
        selectableColumn: {
            show: true,
            icon: 'far fa-edit',
            width: 90
        }
    }
};

export default companyListGridConfig;